import { render, staticRenderFns } from "./TvRemoteControllerSlim2.vue?vue&type=template&id=477dca63"
import script from "./TvRemoteControllerSlim2.vue?vue&type=script&lang=js"
export * from "./TvRemoteControllerSlim2.vue?vue&type=script&lang=js"
import style0 from "./TvRemoteControllerSlim2.vue?vue&type=style&index=0&id=477dca63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports